import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderHandlerService {

  public numberOfRequests: number = 0;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();
  private loadingMessageSubject = new BehaviorSubject<string>('');
  public loadingMessage$ = this.loadingMessageSubject.asObservable();

  handleRequest = (state: string = 'minus'): void => {
    this.numberOfRequests = (state === 'plus') ? this.numberOfRequests + 1 : this.numberOfRequests - 1;
    this.showSpinner.next(this.numberOfRequests > 0);
  };

  startLoading(message: string = ''): void {
    this.loadingMessageSubject.next(message);
    this.isLoadingSubject.next(true);
  }
  
  stopLoading(): void {
    this.isLoadingSubject.next(false);
    this.loadingMessageSubject.next('');
  }
}
